export const MP_API_URI = process.env.MP_API_URI;
export const MP_API_BASE_URL = `http://${MP_API_URI}`;
